<template>
    <div>
        <template v-if="data">
            <div class="nj-cols" style="align-items: center; gap: 2px; grid-template-columns: 40px 4px 40px">
                <input type="text" class="nj-text nj-text-center" v-model="data.hour" :disabled="disabled" :placeholder="showPlaceholders ? 'hora' : ''" maxlength="2" @keyup="input($event)">
                <span class="nj-text-center">:</span>
                <input type="text" class="nj-text nj-text-center" v-model="data.min" :disabled="disabled" :placeholder="showPlaceholders ? 'min' : ''" maxlength="2" @keyup="input($event)">
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "Hora",
    props: {
        data: {
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showPlaceholders: {
            type: Boolean,
            default: true
        },
        id: {
            type: Number,
            default: null
        },
    },
    emits: ["input"],
    methods: {
        input(event) {
            const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "Enter"]
            if (keys.includes(event.key, 0)) {
                // validando que ingrese la hora y el minuto en el formato indicado
                if (this.data) {
                    if (this.data.hour.length == 2) {
                        if (this.data.min.length == 2) {
                            if (keys.includes(event.key, 10)) {
                                this.$emit("input", this.id)
                            }
                        }
                    }
                }
            }
        }
    }
}
</script>

<style scoped></style>